import GetOrderRequestModelBase from '../_generated/modelBases/get-order-request-model-base';

export default class GetOrderRequestModel extends GetOrderRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
